import { ApplicationUser } from "../../users/User.types";
import { Case, RenewalStatus } from "../Case.types";
import { Editability, getEditabilityTooltip, getRenewalEditability } from "../RenewalStatusWidget/renewalEditability";

export type BulkRenewalAction = RenewalStatus.Renew | RenewalStatus.Expire;

export type BulkSelectability = { selectable: boolean; reason: string };

export const remarkMaxLength = 1000;

export function getBulkSelectability(
    selectedCase: Case,
    bulkAction: BulkRenewalAction,
    editSetRenewalStatus: boolean,
    verifiedUser: ApplicationUser | null
): BulkSelectability {
    const editability = getRenewalEditability(selectedCase, editSetRenewalStatus, verifiedUser);
    if (editability !== Editability.Editable) return { selectable: false, reason: getEditabilityTooltip(editability, selectedCase) };

    if ((selectedCase.renewalStatus ?? RenewalStatus.Awaiting) === bulkAction)
        return { selectable: false, reason: `This registration is already set to ${bulkAction === RenewalStatus.Renew ? "renew" : "expire"}.` };

    return { selectable: true, reason: "" };
}

export function getHeaderCheckBoxState(selectableRows: Case[], selectedInternalIds: Set<string>): "true" | "false" | "indeterminate" {
    const selectedCount = selectableRows.filter((x) => selectedInternalIds.has(x.internalId)).length;
    if (selectedCount === 0) return "false";
    if (selectedCount === selectableRows.length) return "true";
    return "indeterminate";
}

// The shared remark is appended to each existing remark with a newline, and the longest result must fit in the database column
export function getMaxSharedRemarkLength(selectedCases: Case[]): number {
    const longestExistingRemark = Math.max(0, ...selectedCases.map((x) => (x.renewalRemark?.trim() ? x.renewalRemark.length + 1 : 0)));
    return Math.max(0, remarkMaxLength - longestExistingRemark);
}
